"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRecordsRequest = void 0;
var NodeBaseRequest_1 = require("./NodeBaseRequest");
var ApiRecordsRequest = /** @class */ (function (_super) {
    __extends(ApiRecordsRequest, _super);
    function ApiRecordsRequest(baseUrl) {
        var _this = _super.call(this) || this;
        _this.baseUrl = baseUrl;
        return _this;
    }
    ApiRecordsRequest.prototype.getbyaddress = function (address, asset) {
        return this.fetchJSON("getbyaddress?address=" + address + "&asset=" + asset);
    };
    ApiRecordsRequest.prototype.getbyaddressfromtransactionlimit = function (address, asset, start, end, type) {
        return this.fetchJSON("getbyaddressfromtransactionlimit?address=" + address + "&asset=" + asset + "&start=" + start + "&end=" + end + "&type=" + type + "&sort=des");
    };
    ApiRecordsRequest.prototype.getfind = function (address, offset, limit) {
        return this.fetchJSON("find?address=" + address + "&type=31&offset=" + offset + "&limit=" + limit);
    };
    ApiRecordsRequest.prototype.pollMessages = function (address, height) {
        return this.fetchJSON("find?address=" + address + "&type=31&startblock=" + height);
    };
    ApiRecordsRequest.prototype.findOrders = function (address, height) {
        return this.fetchJSON("find?address=" + address + "&type=50&startblock=" + height + "&limit=20");
    };
    ApiRecordsRequest.prototype.findAll = function (address, height, offset, limit) {
        return this.fetchJSON("find?address=" + address + "&startblock=" + height + "&offset=" + offset + "&limit=" + limit);
    };
    ApiRecordsRequest.prototype.orderTransaction = function (seqNo) {
        return this.fetchJSON("getbynumber/" + seqNo);
    };
    ApiRecordsRequest.prototype.getTransaction = function (seqNo) {
        return this.fetchJSON("getbynumber/" + seqNo);
    };
    ApiRecordsRequest.prototype.find = function (args) {
        var sep = '';
        var params = '';
        if (args.type) {
            params = "type=" + args.type;
        }
        sep = params.length > 0 ? '&' : '';
        if (args.address) {
            params += sep + "address=" + args.address;
        }
        sep = params.length > 0 ? '&' : '';
        if (args.sender) {
            params += sep + "sender=" + args.sender;
        }
        sep = params.length > 0 ? '&' : '';
        if (args.recipient) {
            params += sep + "recipient=" + args.recipient;
        }
        sep = params.length > 0 ? '&' : '';
        if (args.offset && args.offset >= 0) {
            params += sep + "offset=" + args.offset;
        }
        sep = params.length > 0 ? '&' : '';
        if (args.limit && args.limit >= 0) {
            params += sep + "limit=" + args.limit;
        }
        sep = params.length > 0 ? '&' : '';
        if (args.desc) {
            params += sep + "desc=" + args.desc;
        }
        sep = params.length > 0 ? '?' : '';
        // console.log(`find?${sep}${params}`);
        return this.fetchJSON("find" + sep + params);
    };
    return ApiRecordsRequest;
}(NodeBaseRequest_1.NodeBaseRequest));
exports.ApiRecordsRequest = ApiRecordsRequest;
